import { Box, Typography } from '@mui/material';

type Props = {
  children: React.ReactNode;
};

export function WeekDayCell({ children }: Props) {
  return (
    <Box
      sx={{
        width: '40px',
        height: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography
        sx={{
          color: 'var(--Gray-700, #344054)',
          textAlign: 'center',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '20px',
        }}
      >
        {children}
      </Typography>
    </Box>
  );
}
